import { getQueryParams, SignalData } from '@zonofi/common';
import { Api } from '../api';
import { MessageHistoryRequest, MessageHistoryResponse } from './model';
import { updateSignals } from './slice';

export const msgApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    getMessageHistory: builder.query<
      MessageHistoryResponse,
      MessageHistoryRequest
    >({
      query(args) {
        const { workspaceId } = args;
        return {
          url: `hub/communication-v2/api/communicate/messages`,
          method: 'GET',
          params: { ...args, sellerWorkspaceId: workspaceId },
        };
      },
    }),
    getConversationThreads: builder.query<
      Record<string, SignalData>,
      { conversationThreadIds: string[]; workspaceId: string }
    >({
      query(args) {
        const { conversationThreadIds, workspaceId } = args;
        const params = getQueryParams({
          'conversationThreadIds[]': conversationThreadIds,
          sellerWorkspaceId: workspaceId,
        });
        return {
          url: `hub/communication-v2/api/conversation-threads/ids/${workspaceId}?${params}`,
          method: 'GET',
        };
      },
      transformResponse: (response: Record<string, SignalData>) =>
        Object.fromEntries(
          Object.entries(response).map(([id, data]) => [
            id,
            { ...data, conversationThreadId: id },
          ])
        ),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled.then(({ data }) => {
            dispatch(updateSignals(data));
          });
        } catch (error) {
          console.error(error);
        }
      },
    }),
  }),
});

export const {
  useLazyGetMessageHistoryQuery,
  useLazyGetConversationThreadsQuery,
} = msgApi;
